import { InlineSvg } from 'components/svg';
import { FC } from 'react';

interface DownloadPdfProps {
  fileName?: string | null;
  url?: string | null;
  className?: string;
}

export const DownloadPdf: FC<DownloadPdfProps> = ({ fileName, url, className }) => {
  if (!fileName || !url) {
    return null;
  }

  const handleDownload = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <a
      href={url}
      onClick={handleDownload}
      className={`d-inline-flex align-items-center gap-2 text-decoration-none fw-semibold ${className || ''}`}
      title={`Download ${fileName}`}
    >
      <span>{fileName}</span>
      <InlineSvg path="/media/svg/general/download.svg" svgClassName="mb-1" />
    </a>
  );
};
